import { render, staticRenderFns } from "./live.vue?vue&type=template&id=39835770&scoped=true&"
import script from "./live.vue?vue&type=script&lang=js&"
export * from "./live.vue?vue&type=script&lang=js&"
import style0 from "../style/animate.css?vue&type=style&index=0&lang=css&"
import style1 from "../style/live.css?vue&type=style&index=1&id=39835770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39835770",
  null
  
)

export default component.exports